const fillInObject = (base, overrides) => {
    const out = Object.assign({}, base);
    for (const [key, overrideValue] of Object.entries(overrides)) {
        const baseValue = base[key];
        if (overrideValue instanceof Object) {
            out[key] = fillInObject(baseValue !== null && baseValue !== void 0 ? baseValue : {}, overrideValue);
        }
        else {
            out[key] = overrideValue;
        }
    }
    return out;
};
export { fillInObject };
//# sourceMappingURL=fillInObject.js.map